module.exports = __webpack_public_path__ + "img/account.b99244fd.svg";